module.exports = __webpack_public_path__ + "static/media/industries-chemical-s.c1ba36bc.webp";